import React from 'react'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import { Grid } from "@material-ui/core";

/**
 * Heading bar at the top of some screens, just below application bar.
 */
export default class ScreenHeading extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      title: "",
      icon: "",
      button:""
    }
  }

  componentDidMount() {
    this.setState({ title: this.props.title, icon: this.props.icon, button: this.props.button })
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return
    this.setState({ title: this.props.title, icon: this.props.icon, button: this.props.button })
  }

  render() {
    return (
      <Box style={{ height: '74px' }} >
        <Grid container direction="row" style={{ marginTop: "20px" }}>
          <Grid item md={9}>
            <Typography className="typography-generic header-title" align="center" variant="h2" display="block" >
              {this.state.icon}
              {this.state.title}
            </Typography>
          </Grid>
          {this.state.button !== "" &&
            <Grid item md={3} style={{ display: "flex", justifyContent: "flex-end", position: "relative" }}>
              {this.state.button}
            </Grid>
          }
        </Grid>
        <hr className="hr-custom2"></hr>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/common/ScreenHeading.js